import { Outlet } from "react-router-dom";
import AdminSidebar from "./components/AdminSidebar";
import { UserCircle, Menu, ChevronDown } from "lucide-react"; // Bell a été retiré

// ==================================================
// 🧱 NOUVEAU COMPOSANT : ADMIN HEADER (STYLE MINIMALISTE - SANS CLOCHE)
// ==================================================
function AdminHeader() {
    return (
        // Header plat et épuré. Utiliser le gris clair comme fond pour contraster légèrement.
        <header className="sticky top-0 z-10 px-6 py-3 mb-8 border-b border-gray-200 bg-gray-50">
            <div className="flex items-center justify-between h-8">
                
                {/* Espace pour le titre de la page actuelle ou un message */}
                <div className="hidden text-xl font-bold text-gray-900 lg:block">
                    Bienvenue dans le cockpit
                </div>
                
                {/* Actions à droite */}
                <div className="flex items-center ml-auto space-x-5">
                    
                    {/* La cloche de notification a été supprimée ici. */}

                    {/* Ligne de séparation (maintenue si d'autres éléments sont ajoutés, sinon peut être supprimée) */}
                    {/* Je la retire ici pour un look encore plus simple sans la cloche */}
                    {/* <div className="w-px h-6 bg-gray-200"></div> */}

                    {/* Profil/Avatar et Menu déroulant (fictif) */}
                    <div className="flex items-center space-x-2 cursor-pointer group">
                        
                        {/* Avatar simple */}
                        <div className="flex items-center justify-center w-8 h-8 text-xs font-bold text-gray-600 bg-gray-200 border border-gray-300 rounded-full">
                            SA
                        </div>

                        {/* Nom et icône */}
                        <span className="hidden text-sm font-semibold text-gray-800 md:block">
                            Super Admin
                        </span>
                        
                        <ChevronDown size={16} className="text-gray-400 transition-colors group-hover:text-gray-600" />
                    </div>

                    {/* Menu Toggle pour Mobile */}
                    <button className="p-2 text-gray-600 rounded-lg hover:bg-gray-100 lg:hidden">
                        <Menu size={24} />
                    </button>

                </div>
            </div>
        </header>
    );
}


// ==================================================
// 🧱 COMPOSANT LAYOUT PRINCIPAL
// ==================================================
export default function AdminLayout() {
  return (
    <div className="flex min-h-screen font-sans bg-gray-50"> 
      
      {/* 1. SIDEBAR */}
      <AdminSidebar />
      
      {/* 2. CONTENU PRINCIPAL */}
      <main className="flex-1 overflow-y-auto">
        
        {/* Ajout du Header au début du contenu principal */}
        <AdminHeader />
        
        {/* Le reste du contenu via Outlet */}
        <div className="px-8 pb-8"> 
            <Outlet />
        </div>
        
      </main>
    </div>
  );
}